/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import { ROOT_URL_V2, getCSRFToken } from '../../../../config';
import PopupHeader from '../../../common/PopupHeader';
import { fetchCalendarEvents } from '../../../../actions/Calendar';
import { fetchClientAddressList } from '../../../../actions/ClientData';
import { AgentShiftForm } from '../AgentShiftForm';

import history from '../../../../history';
import { DATE_FORMAT, TIME_FORMAT } from '../../../../consts';

class CalendarCreateShiftContainer extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            errorMessage: null,
        };
    }

    handleFormSubmit(formValues) {
        const self = this;
        this.setState({ errorMessage: undefined });
        const currentUrlParams = new URLSearchParams(history.location.search);
        return axios({
            method: 'post',
            url: `${ROOT_URL_V2}jobs/`,
            data: formValues,
            headers: {
                'X-CSRFToken': getCSRFToken(),
            },
        })
            .then(response => {
                currentUrlParams.delete('createafter');
                currentUrlParams.delete('createbefore');
                currentUrlParams.delete('page');
                history.push({
                    pathname: '/jobs/calendar',
                    search: currentUrlParams.toString(),
                });
                self.props.notification.success(
                    'Success',
                    `Job ${response.data.content.reference_number} successfully created`,
                );
                self.props.load(currentUrlParams, currentUrlParams.get('view'));
            })
            .catch(error => {
                if (error) {
                    if (error.response.data.meta.detail.non_field_errors) {
                        self.setState({
                            errorMessage:
                                error.response.data.meta.detail.non_field_errors.join(
                                    ', ',
                                ),
                        });
                    } else {
                        self.setState({
                            errorMessage: JSON.stringify(
                                error.response.data.meta.detail,
                            ),
                        });
                    }
                }
            });
    }

    onDismiss = () => {
        this.props.fetchClientAddressList([]);
        const { history } = this.props;
        const currentUrlParams = new URLSearchParams(history.location.search);
        currentUrlParams.delete('createafter');
        currentUrlParams.delete('createbefore');
        history.push({
            pathname: '/jobs/calendar',
            search: currentUrlParams.toString(),
        });
        this.props.load(currentUrlParams, currentUrlParams.get('view'));
    };

    render() {
        const currentUrlParams = new URLSearchParams(history.location.search);
        const createAfter = currentUrlParams.get('createafter');
        const createBefore = currentUrlParams.get('createbefore');
        const service = currentUrlParams.get('service');
        const vehicle_type = currentUrlParams.get('vehicle_type') || 2;
        const role = currentUrlParams.get('role') || 'WA';
        let duration =
            createAfter && createBefore
                ? moment(createBefore).diff(moment(createAfter), 'hours', true)
                : 4;
        if (duration < 3) {
            duration = 4;
        }
        const job = {
            number_of_freelancers: 1,
            start_time: createAfter
                ? moment(createAfter).format(TIME_FORMAT)
                : moment(Date.now())
                      .add(4, 'hours')
                      .startOf('hour')
                      .format(TIME_FORMAT),
            date: createAfter
                ? moment(createAfter).format(DATE_FORMAT)
                : moment(Date.now()).add(3, 'hours').format(DATE_FORMAT),
            duration,
        };

        if (service == 'hospitality') {
            job.service = 'hospitality';
            job.role = role;
        } else {
            job.service = 'driver';
            job.vehicle_type = vehicle_type;
            job.minimum_delivery_box = 4;
            job.own_vehicle = true;
        }

        return (
            <div className="create-shift">
                <PopupHeader title="&nbsp;" onDismiss={this.onDismiss} />
                <AgentShiftForm
                    mode="create"
                    defaultJob={job}
                    handleFormSubmit={this.handleFormSubmit.bind(this)}
                    errorMessage={this.state.errorMessage}
                    onDismiss={this.onDismiss}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
});
const mapDispatchToProps = (dispatch, ownProps) => ({
    load: (searchParams, view) =>
        dispatch(fetchCalendarEvents(searchParams, view)),
    fetchClientAddressList,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CalendarCreateShiftContainer);
